import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  HrParagraph,
  HrFlexContainer,
  HrTitleContainer,
  HrTitleH4,
  HrActionText,
  HrPrimary,
  HrButtons
} from '@components/styles/hr-styles';
import { Modal } from '../modal';
import { DisplaySettingsContext } from '../../store/display-settings';

export const ModalFaqs = ({ setShowModalShowErrors, setShowModalFaqs, trigger }) => {
  const [t] = useTranslation();
  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);
  const pathLogo = '../../../../../assets/img/app/';
  return (
    <Modal setShowModal={setShowModalFaqs}>
      <HrTitleContainer padding='32px 24px 16px 24px' gap='4px'>
        <span style={{ color:darkMode ? 'white' : '' }} className='hr-Question' />
        <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>{t('postulant.modal.faqs.title')}</HrTitleH4>
      </HrTitleContainer>
      <HrFlexContainer flexDirection='column' padding='24px'>
        <HrFlexContainer flexDirection='column' alignItems='flex-start'>
          <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>{t('postulant.modal.faqs.text')}</HrParagraph>
          <a
            style={{ textDecoration: 'none' }}
            target='_blanck'
            href='https://intercom.help/hiringroom/es/articles/4359811-como-me-postulo'
          >
            <HrActionText fontSizeSetting={fontSizeSetting} color={HrPrimary}>
              <span className='hr-Carret-right' />
              {t('postulant.modal.faqs.link_one')}
            </HrActionText>
          </a>
          <a
            style={{ textDecoration: 'none' }}
            target='_blanck'
            href='https://intercom.help/hiringroom/es/articles/4359747-actualiza-tu-perfil'
          >
            <HrActionText fontSizeSetting={fontSizeSetting} color={HrPrimary}>
              <span className='hr-Carret-right' />
              {t('postulant.modal.faqs.link_two')}
            </HrActionText>
          </a>
          <a
            style={{ textDecoration: 'none' }}
            target='_blanck'
            href='https://intercom.help/hiringroom/es/articles/4359831-recomendaciones'
          >
            <HrActionText fontSizeSetting={fontSizeSetting} color={HrPrimary}>
              <span className='hr-Carret-right' />
              {t('postulant.modal.faqs.link_three')}
            </HrActionText>
          </a>
          <HrActionText
            fontSizeSetting={fontSizeSetting}
            color={HrPrimary}
            onClick={() => {
              trigger();
              setShowModalFaqs(false);
              setShowModalShowErrors(true);
            }}
            onKeyPress={() => {
              trigger();
              setShowModalFaqs(false);
              setShowModalShowErrors(true);
            }}
          >
            <span className='hr-Carret-right' />
            {t('postulant.modal.faqs.link_four')}
          </HrActionText>
        </HrFlexContainer>
        <HrFlexContainer justifyContent='space-between'>
          <img height={darkMode ? '' : '30px'} src={`${pathLogo}${darkMode ? 'HiringRoom-logo_footer_negativo_2.png' : 'HiringRoom-logo_footer.png'}`} alt='Logo HiringRoom' />
          <HrButtons
            type='button'
            category='cancel'
            size='medium'
            style={{fontSize: `${14 + fontSizeSetting}px`}}
            onClick={() => {
              setShowModalFaqs(false);
            }}
          >
            {t('general.button.close')}
          </HrButtons>
        </HrFlexContainer>
      </HrFlexContainer>
    </Modal>
  );
};
